import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined, BankOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";


function useLazySelect(apiUrl, key, mapper, enableCache = true) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    if (enableCache && loaded) return; // 缓存模式
    setLoading(true);
    try {
      const res = await http.get(apiUrl);
      const list = res?.data?.[key] || res?.data || [];
      setOptions(mapper(list));
      setLoaded(true);
    } catch (err) {
      console.error("Select load error:", err);
    } finally {
      setLoading(false);
    }
  };

  return { options, loading, load };
}

const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);


  // const stateSelect = useLazySelect(
  //   api.getStateDictList,
  //   "state",
  //   (data) => data.map((s) => ({ label: s, value: s }))
  // );

  const stateSelect = useLazySelect(api.getStateDictList, "state", (data) =>
  Object.entries(data || {}).map(([key, label]) => ({
    label,   
    value: key, 
  })),
);
  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      form.resetFields();
      setVisible(true);
      await stateSelect.load(); // 打开时直接加载
    },
  }));


  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await http.post(api.getGroupAdd, values);

      if (res?.code === "1") {
        message.success("Owner Created Successfully");
        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(res?.msg || "Create failed");
      }
    } catch (err) {
      console.error(err);
      message.error(err?.msg || "Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            ADD GROUP
          </Typography.Title>
        </Flex>
      }
      width="60%"
      open={visible}
      maskClosable={false}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      footer={
          <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              name="createOwnerForm"
              layout="horizontal"
              labelCol={{ style: { width: "200px" } }}
              wrapperCol={{ style: { flex: 1 } }}
              onFinish={onFinish}
            >
              <Flex align="flex-start" justify="space-between" gap={32}>
                <div style={{ flex: 1 }}>
                  <div className="modal-section-title">
                    <BankOutlined /> Group Information
                  </div>

                  <Form.Item
                    name="groupCode"
                    label="Group Code"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Group Code" />
                  </Form.Item>

                  <Form.Item name="groupName" label="Group Name"  rules={[{ required: true }]}>
                    <Input placeholder="Group Name" />
                  </Form.Item>

                  <Form.Item
                    name="street"
                    label="Street"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Street" />
                  </Form.Item>

                  <Form.Item
                    name="city"
                    label="City"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="City" />
                  </Form.Item>


                  <Form.Item
                    name="county"
                    label="County"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="County" />
                  </Form.Item>

                  <Form.Item
                    name="zip"
                    label="Zip"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Zip" />
                  </Form.Item>

                  <Form.Item
                    name="state"
                    label="State"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Select State"
                      loading={stateSelect.loading}
                      options={stateSelect.options}
                    />
                  </Form.Item>

                  <Form.Item
                    name="zip"
                    label="Zip"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Zip" />
                  </Form.Item>

                  <Form.Item name="phone" label="Phone">
                    <Input placeholder="Phone" />
                  </Form.Item>

                  <Form.Item name="officeHour" label="Office Hours">
                    <Input placeholder="Office Hours" />
                  </Form.Item>
                </div>
              </Flex>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;
